import { inject, reactive, ref } from 'vue';
export const useVerification = () => {
    const emitter = inject('emitter');
    const isErrorVerifyingDomain = reactive({ state: false, errorMessage: '' });
    const isLoading = ref(false);
    const onAuthorized = (payload) => {
        isLoading.value = true;
        isErrorVerifyingDomain.state = false;
        isErrorVerifyingDomain.errorMessage = '';
        emitter.emit('onSendDomainConnectPayload', payload);
    };
    const onReceivedConfirmation = (payload) => {
        var _a;
        if (payload.flag) {
            isLoading.value = false;
            isErrorVerifyingDomain.state = false;
            isErrorVerifyingDomain.errorMessage = undefined;
        }
        else {
            isLoading.value = false;
            isErrorVerifyingDomain.state = true;
            isErrorVerifyingDomain.errorMessage = (_a = payload.errorMessage) !== null && _a !== void 0 ? _a : '';
        }
    };
    return {
        onAuthorized,
        onReceivedConfirmation,
        isErrorVerifyingDomain,
        isLoading,
    };
};
